export interface EventData {
  type: "init" | "destroy" | "reqsvg" | "retsvg";
  id: string;
}

export interface InitEventData extends EventData {
  type: "init";
}

export function isInitEvent(data: EventData): data is InitEventData {
  return data.type === "init";
}

export interface DestroyEventData extends EventData {
  type: "destroy";
}

export function isDestroyEvent(data: EventData): data is DestroyEventData {
  return data.type === "destroy";
}

export interface ReqSvgEventData extends EventData {
  type: "reqsvg";
  abc: string;
}

export function isReqSvgEvent(data: EventData): data is ReqSvgEventData {
  return data.type === "reqsvg";
}

export interface RetSvgEventData extends EventData {
  type: "retsvg";
  svg: string;
  error_html: string;
}

export function isRetSvgEvent(data: EventData): data is RetSvgEventData {
  return data.type === "retsvg";
}



// WEBPACK FOOTER //
// ./src/abcSvg/events.ts